import type {RegionConfig} from '@frontend/types/Locales'
import {splitVnFullName} from '../../helpers/splitVnFullName'

export const VnRegionConfig: RegionConfig = {
    region: 'vn',
    defaultLanguage: 'vi',
    label: 'Việt Nam / Vietnam',
    variations: ['vi', 'vn', 'vi-vn', 'vi_vn'],
    defaultCity: 'Hồ Chí Minh',
    demoAdvertisement: {
        priceFloat: 1500000,
        price: '1 500 000 VND',
        previousPrice: '3 000 000 VND',
        discountPercent: 50,
    },
    currencyCode: 'VND',
    numeral: {
        localeConfig: {
            currency: {
                symbol: ' VND',
            },
        },
        defaultFormat: '0,0$',
    },
    phone: {
        template: '0___ ___ ___',
        minCursorPosition: 1,
        validationRegexp: /^(0[03-9]\d{2}\s*\d{3}\s*\d{3})$/,
    },
    verificationCode: {
        digits: 4,
        placeholder: '____',
        resendTimeout: 120,
        validationRegexp: /^\d+$/,
    },
    allowedEmailDomains: [
        'gmail.com',
        'yahoo.com.vn',
        'yahoo.com',
        'outlook.com',
        'hotmail.com',
        'icloud.com',
        'vnn.vn',
        'viettel.com.vn',
        'fpt.com.vn',
        'fpt.vn',
        'pavietnam.vn',
        'vhost.vn',
        'vinahost.vn',
        'matbao.com',
        'tenten.vn',
        'bkav.com.vn',
        'cmc.com.vn',
        'hanmail.net',
        'naver.com',
    ],
    clientSurvey: {
        steps: 3,
        monthlyIncome: {
            maxDigits: 8,
            minValue: 1000000,
            maxValue: 99999999,
        },
        bankAccount: {
            minLength: 6,
            maxLength: 16,
            allowedChars: /\d/,
            validationRegexp: /^\d{6,16}$/,
        },
        bankCardNumber: {
            validationRegexp: /^\d{16}$/, // < todo: добавить валидацию вендора карты.
        },
        drivingLicense: {
            minLength: 12,
            maxLength: 12,
            allowedChars: /\d/,
            validationRegexp: /^\d{12}$/,
        },
        passportNumber: {
            template: '___ ___ ___ ___',
            minCursorPosition: 0,
            minLength: 12,
            maxLength: 12,
            validationRegexp: /^\d{12}$/,
        },
    },
    contacts: {
        phone: '1900 9898 44',
        email: 'support@dotoku.com',
        facebook: 'https://www.facebook.com/dotokuvietnam/?locale=vi_VN',
        zalo: 'https://zalo.me/dotokuvietnam19',
    },
    moneyInput: {
        numeralFormat: '0,0',
        numeralFormatForPriceFilter: '0,0',
        allowedChars: /[0-9]/,
    },
    birthDate: {
        minAge: 18,
        maxAge: 65,
    },
    adPrice: {
        maxDigits: 11, // ~380000$
        maxValue: 99999000000,
        minValue: 10000,
    },
    adDescription: {
        minWords: 8,
        // Detects price patterns in multi-line Vietnamese ad descriptions.
        // Matches: plain numbers, numbers with ,/. thousand-separators (e.g. 1,500,000 or 1.500.000),
        // and decimal shorthand (e.g. 1.5) followed by currency/unit keywords.
        // Units: VND, VNĐ, đồng/dong/₫/đ/Đ, triệu (tr), tỷ, nghìn/ngàn, k (thousands).
        // Guards on `tr` and `k` prevent false positives in Vietnamese words (e.g. "trong", "không").
        priceDetectionRegexp: /\d[\d.,]*\s*(?:VND|VNĐ|triệu|tỷ|nghìn|ngàn|đồng|dong|₫|Đ(?!\p{L})|đ(?!\p{L})|tr(?![a-zA-Z])|k(?![a-zA-Z]))/imu,
    },
    googleMaps: {
        adCreationForm: {
            defaultCenter: {
                lat: 10.762622,
                lng: 106.660172,
            },
            defaultZoom: 8,
            addressZoom: 15,
        },
    },
    splitFullUserName: splitVnFullName,
    makeFullUserName(firstName: string | null, lastName: string | null): string {
        return (`${lastName ?? ''} ${firstName ?? ''}`).trim()
    },
}
